import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';

import { Button } from '@this/shared/ui/inputs/button';
import { Input } from '@this/shared/ui/inputs/input';
import { useAITTheme } from '@this/shared/ui/theme';
import type HotelBaseScore from '@this/domain/hotel_base_score';
import { Fetcher, HTTPError } from '@this/src/util';

import Notification from '../../../notification';
import { getStyles } from './repository_display_adjustment.styles';

type Props = {
  scores: HotelBaseScore[];
};

const HotelBaseScoresForm: React.FC<Props> = ({ scores }) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const [errors, setErrors] = useState<string[]>([]);

  const updateHotelBaseScore = async (s: HotelBaseScore) => {
    setErrors([]);
    try {
      await Fetcher.put(`/admin/repository_display_adjustment/hotel_base_scores/${s.id}.json`, s.submitParams());
      Notification.success('ホテル基本スコアを更新しました');
    } catch (e) {
      if (e instanceof HTTPError && e.response?.status === 400) {
        const permissionMessage = e.response.data.message;
        const validationErrors = e.response.data.errors;
        setErrors(validationErrors || [permissionMessage]);
      } else {
        setErrors(['通信エラーが発生しました。時間をおいて再度お試しください。']);
      }
    }
  };

  return (
    <>
      <div style={styles.inlineFormList}>
        {scores.map((s, i) => (
          <form
            key={i}
            style={styles.inlineFormRow}
            onSubmit={e => {
              e.preventDefault();
              updateHotelBaseScore(s);
            }}
          >
            <label htmlFor={s.provider} style={styles.inlineFormLabel}>
              {s.provider}
            </label>
            <Input
              id={s.provider}
              type="number"
              inputProps={{ step: 0.1 }}
              value={s.value}
              style={styles.inlineFormInput}
              onChange={e => {
                s.value = Number(e.target.value);
              }}
            />
            <Button type="submit" color="primary" size="small" style={styles.submitButton}>
              更新
            </Button>
          </form>
        ))}
      </div>
      {!_.isEmpty(errors) &&
        errors.map((e, i) => (
          <p key={i} style={styles.errorText}>
            {e}
          </p>
        ))}
    </>
  );
};

export default observer(HotelBaseScoresForm);
